import { z } from "zod";

import { ScheduleActionTypeList, ScheduleDtoSchema } from "../../dtos/schedule";

export const PutTestScheduleRequestBodySchema = z.object({
  experienceId: z.string().uuid(),
  executionTime: z.number(),
  action: z.enum(ScheduleActionTypeList),
});

export type PutTestScheduleRequestBodyType = z.infer<
  typeof PutTestScheduleRequestBodySchema
>;

export const PutTestScheduleResponseBodySchema = z.object({
  schedules: ScheduleDtoSchema.array(),
});

export type PutTestScheduleResponseBodyType = z.infer<
  typeof PutTestScheduleResponseBodySchema
>;
